import { getGetCourierQueryKey, getGetCourierSpaceQueryKey, getListCourierSpacesQueryKey, getListCouriersQueryKey } from "@/app/generated/api/courier/courier";
import { getListFleetVehiclesQueryKey } from "@/app/generated/api/fleet/fleet";
import { CourierSetupFields } from "./CourierSetupFields";
import { createCourierInput, resolveCourierSelections, validCourierMembers, validCourierPlatforms, validCourierSetup } from "./courierSetup";
import type { IndustrySetupDriver } from "./types";

export const courierIndustrySetup: IndustrySetupDriver = {
  presetCode: "courier",
  titleKey: "apps.presets.items.courier.title",
  defaultNameKey: "courier.defaultName",
  displayNameLabelKey: "courier.teamName",
  usePersonalName: false,
  displayNameMaxLength: 160,
  allowInstallOnly: false,
  descriptionKey: "courier.description",
  completionLabelKey: "courier.complete",
  setupSteps: ["courier.team", "courier.platforms", "courier.vehicles", "courier.review"],
  defaultInput: {},
  createInput: createCourierInput,
  isValid: validCourierSetup,
  isStepValid: (input, step) => Boolean(input.installOnly) || (step === 0 ? validCourierMembers(input.courierSetup)
    : step === 1 ? validCourierPlatforms(input.courierSetup) : validCourierSetup(input)),
  prepareInput: (input) => input.installOnly ? { ...input, courierSetup: undefined } : input,
  requiredRecommendedApps: [],
  Fields: CourierSetupFields,
  resolveSelections: resolveCourierSelections,
  destination: (workspaceUuid, result) => result.completed && result.courierSpaceUuid
    ? `/c/${workspaceUuid}/courier/${result.courierSpaceUuid}${result.courierUuid ? `/couriers/${result.courierUuid}` : ""}`
    : `/c/${workspaceUuid}/apps/presets`,
  invalidationKeys: (workspaceUuid, result) => [
    getListCourierSpacesQueryKey(workspaceUuid),
    getListFleetVehiclesQueryKey(workspaceUuid),
    ...result.courierSpaceUuid ? [getGetCourierSpaceQueryKey(workspaceUuid, result.courierSpaceUuid), getListCouriersQueryKey(workspaceUuid, result.courierSpaceUuid)] : [],
    ...result.courierSpaceUuid && result.courierUuid ? [getGetCourierQueryKey(workspaceUuid, result.courierSpaceUuid, result.courierUuid)] : [],
  ],
};
